import { Tag, TagProps } from '@nimbus-ds/components';
import { CheckCircleIcon } from '@nimbus-ds/icons';
import { ProductTransferListResponseDto } from '@tiendanube/common';
import { useTranslationCatalog } from 'domains/Catalog/hooks';

const statusMap: Record<
  ProductTransferListResponseDto[number]['status'],
  TagProps['appearance']
> = {
  pending: 'primary',
  ready: 'success',
  failed: 'warning',
};

const iconMap: Record<
  ProductTransferListResponseDto[number]['status'],
  React.ReactNode
> = {
  pending: undefined,
  ready: <CheckCircleIcon />,
  failed: undefined,
};

function TransferStatus({
  status,
}: Readonly<{ status: ProductTransferListResponseDto[number]['status'] }>) {
  const t = useTranslationCatalog('transfers.list');
  return (
    <Tag appearance={statusMap[status]}>
      {' '}
      {iconMap[status]} {t(`status.${status}`)}
    </Tag>
  );
}

export default TransferStatus;
